// extracted by mini-css-extract-plugin
export var container = "_cc-1";
export var cornerButtonContainer = "_cc-6";
export var disabled = "_cc-2";
export var dragActive = "_cc-3";
export var fileContainer = "_cc-5";
export var hiddenInput = "_cc-4";
export var widthContainer = "_cc-0";